import { Toast } from 'vant'
import 'vant/lib/index.css'

export function toast(message, duration = 1000) {
    Toast({
        message, duration
    });
}

export function toasts(message,toastClassName, duration = 1000) {
    Toast.success({
        message, duration,
		overlay:true,
        className:toastClassName,
    });
}

export function toastf(message, duration = 1000) {
    Toast.fail({
        message, duration
    });
}

export function toaste(message, duration = 1000) {
    Toast.error({
        message, duration
    });
}